/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialUserUpdateRequest } from '../../models/editorial-user-update-request';
import { UserAdminResponse } from '../../models/user-admin-response';

export interface UpdateUserAdmin$Params {
  userId: number;
      body: EditorialUserUpdateRequest
}

export function updateUserAdmin(http: HttpClient, rootUrl: string, params: UpdateUserAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAdminResponse>> {
  const rb = new RequestBuilder(rootUrl, updateUserAdmin.PATH, 'put');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAdminResponse>;
    })
  );
}

updateUserAdmin.PATH = '/api/editorial/user-admins/{userId}';
